import React from 'react';

//functions
import { handleChangeToPersonal, handleChangeToTeam } from './functions/ChangeTokens';

const TeamToken = ({profile, teamToken, auth}) => {
    
    return (
        <div>
            <h2 className="mb-2 text-gray-500 text-xs font-medium uppercase tracking-wide">Tokens</h2>
            <div className="mb-4 text-sm font-medium text-gray-600">
                Current Mode: 
                { !teamToken?.[0]?.teamToken ? 
                 <span className="bg-yellow-500 px-2 py-1 rounded-md text-white ml-2">Personal Mode</span>
                 :
                 <span className="bg-blue-500 px-2 py-1 rounded-md text-white ml-2">Team Mode</span>
                }
            </div>
            <div className="bg-white shadow sm:rounded-lg">
            <div className="px-4 py-5 sm:p-6">
                { !teamToken?.[0]?.teamToken ? 
                <h3 className="text-lg leading-6 font-medium text-gray-900">Switch to Team Mode</h3>
                :
                <h3 className="text-lg leading-6 font-medium text-gray-900">Switch to Personal Mode</h3>
                }
                {!teamToken?.[0]?.teamToken ?
                <div className="mt-2 max-w-xl text-sm text-gray-500">
                <p>If you switch to team mode your team will be using the tokens on your account for message generation. Not their personal ones. This is good for teams that pool tokens. You have unlimited seats available for team mode.</p>
                </div>
                :
                <div className="mt-2 max-w-xl text-sm text-gray-500">
                <p>If you switch to personal mode, team members will not have access to your tokens. They will only be able to generate messages based on tokens in their account</p>
                </div>
                
                }
                
                <div className="mt-5">
                { !teamToken?.[0]?.teamToken ? 
                <button
                    type="button"
                    className="inline-flex items-center justify-center px-4 py-2 border border-transparent font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm"
                    onClick={()=>handleChangeToTeam(profile, auth)}
                >
                    Switch to Team Mode
                </button>
                :
                <button
                    type="button"
                    className="inline-flex items-center justify-center px-4 py-2 border border-transparent font-medium rounded-md text-yellow-700 bg-yellow-100 hover:bg-yellow-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:text-sm"
                    onClick={()=>handleChangeToPersonal(profile, auth)}
                >
                    Personal tokens
                </button>
                }
                </div>
                </div>
            </div>
        </div>
    )
}

export default TeamToken
